import { isStarterPricePlan } from './pricePlan'

/**
 * Whether a visual signature should carry the Skribble logo (the Starter-plan
 * branding).
 *
 * Product rule: the logo is shown only when BOTH the signing user and the
 * inviting (signature request) business are on the Starter plan.
 *
 *   1. Starter user signs their own SR         -> show
 *   2. Starter user signs a paid-plan SR       -> hide
 *   3. Non-starter signer, non-starter inviter -> hide
 *   4. Non-starter signer of a Starter SR      -> hide
 *
 * This is the front-end *preview* decision. The copy that ends up in the signed
 * PDF is currently decided server-side in Phoebe (handlers/documents.py) and
 * must stay in sync with this rule until the sign/render flow moves to
 * WaveRunner, at which point this helper becomes the single source of truth for
 * both the preview and the embedded signature.
 */
export function shouldShowSkribbleLogo(signerPlan?: string | null, invitingPlan?: string | null): boolean {
  return isStarterPricePlan(signerPlan) && isStarterPricePlan(invitingPlan)
}
